import { render, staticRenderFns } from "./BaseRealNameModify.vue?vue&type=template&id=567128f0&scoped=true"
import script from "./BaseRealNameModify.vue?vue&type=script&lang=js"
export * from "./BaseRealNameModify.vue?vue&type=script&lang=js"
import style0 from "./BaseRealNameModify.vue?vue&type=style&index=0&id=567128f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567128f0",
  null
  
)

export default component.exports